<template>
  <footer class="page-footer">
    <div class="container">
      <div
        class="footer-inner d-flex flex-wrap align-items-center text-left justify-content-between"
      >
        <div class="copy-txt">
          © 2015-{{ Year() }}. All rights reserved by
          <a href="https://axilweb.com">Axilweb Limited</a> |
          <a href="/privacy-policy">Privacy Policy</a>
        </div>

        <ul class="social-links">
          <li>
            <a
              href="https://www.facebook.com/axilwebltd/"
              target="_blank"
              aria-label="Facebook"
              rel="noopener noreferrer"
              ><i class="fab fa-facebook-f"></i
            ></a>
          </li>
          <li>
            <a
              href="https://twitter.com/axilweb"
              target="_blank"
              aria-label="Twitter"
              rel="noopener noreferrer"
              ><i class="fab fa-twitter"></i
            ></a>
          </li>
          <li>
            <a
              href="https://www.linkedin.com/company/axilwebltd/"
              target="_blank"
              aria-label="Linkedin"
              rel="noopener noreferrer"
              ><i class="fab fa-linkedin-in"></i
            ></a>
          </li>
          <li>
            <a
              href="https://www.instagram.com/axilweb/"
              target="_blank"
              aria-label="Instagram"
              rel="noopener noreferrer"
              ><i class="fab fa-instagram"></i
            ></a>
          </li>
          <li>
            <a
              href="https://www.behance.net/axilweb"
              target="_blank"
              aria-label="Behance"
              rel="noopener noreferrer"
              ><i class="fab fa-behance"></i
            ></a>
          </li>
          <li>
            <a
              href="https://dribbble.com/axilweb"
              target="_blank"
              aria-label="Dribbble"
              rel="noopener noreferrer"
              ><i class="fab fa-dribbble"></i
            ></a>
          </li>
        </ul>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  methods: {
    Year() {
        var dt = new Date();
      return dt.getFullYear();
    },
  },
};
</script>
